<mat-horizontal-stepper labelPosition="bottom" [selectedIndex]="stepIndex" *ngIf="flujoCompleto" disabled  #stepper>
    <mat-step [completed]="completedSolicitado">
        <ng-template matStepLabel>Solicitado</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>
    </mat-step>
    <mat-step [completed]="completedRevision">
      <ng-template matStepLabel>Revisión Documentos</ng-template>
    </mat-step>
    <mat-step [completed]="completedProgramacion">
      <ng-template matStepLabel>Programación Inducciones</ng-template>
    </mat-step>
    <mat-step [completed]="completedResultados">
      <ng-template matStepLabel>Registro Resultados Inducciones</ng-template>
    </mat-step>
    <mat-step [completed]="completedAutorizacion">
      <ng-template matStepLabel>Autorización Accesos</ng-template>
    </mat-step>
    <mat-step [completed]="completedFinalizado">
      <ng-template matStepLabel>Finalizado</ng-template>
    </mat-step>
  </mat-horizontal-stepper>
  <mat-horizontal-stepper labelPosition="bottom" [selectedIndex]="stepIndex" *ngIf="!flujoCompleto" disabled>
    <mat-step [completed]="completedSolicitado">
        <ng-template matStepLabel>Solicitado</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>
    </mat-step>
    <mat-step [completed]="completedRevision">
      <ng-template matStepLabel>Revisión Documentos</ng-template>
    </mat-step>
    <mat-step [completed]="completedFinalizado">
      <ng-template matStepLabel>Finalizado</ng-template>
    </mat-step>
  </mat-horizontal-stepper>